export const EnumTipoAgenda = () => {
  return [
    { tipo: 'VIRTUAL', descricao: 'Virtual' },
    { tipo: 'PRESENCIAL', descricao: 'Presencial' },
  ];
};
